/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseImportProfile } from '../../models/api-response-import-profile';

export interface ImportProfile$Params {
  'x-api-requestId'?: string;
  entityType: string;
}

export function importProfile(http: HttpClient, rootUrl: string, params: ImportProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportProfile>> {
  const rb = new RequestBuilder(rootUrl, importProfile.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.path('entityType', params.entityType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseImportProfile>;
    })
  );
}

importProfile.PATH = '/v1/api/ui/imports/profiles/{entityType}';
